import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <header className="bg-white py-4 px-4 sm:px-8">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img 
            src="/Practice Dashboard favicon.png" 
            alt="Practice Dashboard Logo" 
            className="w-8 h-8 sm:w-10 sm:h-10 mr-2 sm:mr-3 rounded-full"
          />
          <h1 className="text-lg sm:text-xl font-semibold text-gray-900">
            <span className="hidden sm:inline">Practice Dashboard</span>
            <span className="sm:hidden">Practice</span>
          </h1>
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <Link 
            to="/pricing" 
            className={`font-medium transition-colors min-h-[44px] flex items-center ${
              location.pathname === '/pricing' 
                ? 'text-orange-500' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            Pricing
          </Link>
          <Link 
            to="/contact" 
            className={`font-medium transition-colors min-h-[44px] flex items-center ${
              location.pathname === '/contact' 
                ? 'text-orange-500' 
                : 'text-gray-700 hover:text-gray-900'
            }`}
          >
            Contact Us
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <X className="w-6 h-6 text-gray-700" />
          ) : (
            <Menu className="w-6 h-6 text-gray-700" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden mt-4 pb-4 border-t border-gray-200">
          <nav className="flex flex-col space-y-2 pt-4">
            <Link 
              to="/pricing" 
              onClick={() => setMobileMenuOpen(false)}
              className={`font-medium transition-colors px-4 py-3 rounded-lg min-h-[44px] flex items-center ${
                location.pathname === '/pricing' 
                  ? 'text-orange-500 bg-orange-50' 
                  : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              Pricing
            </Link>
            <Link 
              to="/contact" 
              onClick={() => setMobileMenuOpen(false)}
              className={`font-medium transition-colors px-4 py-3 rounded-lg min-h-[44px] flex items-center ${
                location.pathname === '/contact' 
                  ? 'text-orange-500 bg-orange-50' 
                  : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              Contact Us
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;